import React from 'react';
import {
  Descriptions,
  Card,
  Statistic,
  Row,
  Col,
  List,
  Empty,
  Button,
} from 'antd';
import { Link, useParams } from 'react-router-dom';
import DateDisplay from '../../layout/DateDisplay';
import { useHasScopeTypeInProject } from 'hooks';
import { PrivateComponent } from 'components/auth';
import { FileList, SanitizedHTML } from 'components/layout';
import { ENUM_RESEARCH_RELATED } from 'constants/form';

const EmptyProfile = () => {
  const { projectId } = useParams();
  // console.log(projectId);
  return (
    <Empty description="No profile yet">
      <Link to={`/projects/${projectId}/profile/edit`}>
        <Button type="primary">Create now</Button>
      </Link>
    </Empty>
  );
};

const ProfileDescriptions = ({ data }) => {
  const { projectId } = useParams();
  const { hasScopeType: canViewProjectProposal } = useHasScopeTypeInProject(
    'VIEW_PROJECT_PROPOSAL'
  );
  const { hasScopeType: canViewHistoryLogByPMS } = useHasScopeTypeInProject(
    'VIEW_HISTORY_LOG_BY_PMS'
  );

  const { projects } = data;
  const project = projects?.nodes[0];
  const {
    title,
    projectStatus,
    projectCategory,
    profile,
    // projectBudget,
  } = project;

  return profile ? (
    <>
      <PrivateComponent expectedScopeType={['WRITE_PROJECT']}>
        <Button type="primary" style={{ marginBottom: '24px' }}>
          <Link to={`/projects/${projectId}/profile/edit`}>Edit profile</Link>
        </Button>
      </PrivateComponent>
      <Descriptions
        title="General"
        column={{ xxl: 3, xl: 3, lg: 2, md: 2, sm: 2, xs: 1 }}
      >
        <Descriptions.Item label="Project Title">{title}</Descriptions.Item>
        <Descriptions.Item label="Project Category">
          {projectCategory.name}
        </Descriptions.Item>
        <Descriptions.Item label="Project Type">
          {profile && profile.projectType?.name}
        </Descriptions.Item>
        <Descriptions.Item label="Project Code">
          {profile && profile.projectCode}
        </Descriptions.Item>
        <Descriptions.Item label="Account Code">
          {profile && profile.accountCode}
        </Descriptions.Item>
        <Descriptions.Item label="Work Programme Code">
          {profile && profile.workProgramme}
        </Descriptions.Item>
        <Descriptions.Item label="Account Set Up Date">
          <DateDisplay date={profile && profile.accountSetUpDate} />
        </Descriptions.Item>
        <Descriptions.Item label="Account Closed Date">
          <DateDisplay date={profile && profile.accountClosedDate} />
        </Descriptions.Item>
        <Descriptions.Item label="Research-oriented or with research elements ">
          {profile && ENUM_RESEARCH_RELATED[profile.researchRelated]}
        </Descriptions.Item>
        <Descriptions.Item label="Faculty / School">
          {profile && profile.department.faculty.name}
        </Descriptions.Item>
        <Descriptions.Item label="Department">
          {profile && profile.department.name}
        </Descriptions.Item>
        <Descriptions.Item label="Project status">
          {projectStatus ? projectStatus.name : '-'}
        </Descriptions.Item>
      </Descriptions>
      <Card title="Funding" style={{ marginTop: '24px' }}>
        {/* <Row gutter={[16, 16]}> */}
        {/* <Col xs={24} > */}
        <Statistic
          title="Total Project Funding"
          prefix="$"
          precision={2}
          value={profile.totalFunding}
        />
        {/* </Col> */}
        {/* <Col xs={24} md={12} xl={8}>
            <Statistic
              title="Total Budget Allocation Funding"
              prefix="$"
              precision={2}
              value={projectBudget.total}
              valueStyle={
                projectBudget.total > profile.totalFunding
                  ? { color: TEXT_COLOR_DANGER }
                  : {}
              }
            />
          </Col> */}
        {/* </Row> */}
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={12}>
            <Card
              type="inner"
              title="Approved Funding"
              style={{ marginTop: '24px' }}
            >
              <Descriptions
                title={profile && profile.approvedFunding.source.name}
              >
                <Descriptions.Item label="Funding Amount" span={3}>
                  <Statistic
                    prefix="$"
                    precision={2}
                    value={profile ? profile.approvedFunding.amount : 0}
                    valueStyle={{ fontSize: '14px' }}
                  />
                </Descriptions.Item>
                <Descriptions.Item label="Condition of Allocation" span={3}>
                  {profile && profile.approvedFunding.conditionOfAllocation}
                </Descriptions.Item>
              </Descriptions>
            </Card>
          </Col>
          <Col xs={24} xl={12}>
            {profile && profile.additionalFunding.length > 0 && (
              <Card
                type="inner"
                title="Additional Funding"
                style={{ marginTop: '24px' }}
              >
                <List>
                  {profile &&
                    profile.additionalFunding.map(
                      ({ source, amount, conditionOfAllocation }, index) => (
                        <List.Item key={index}>
                          <Descriptions title={source.name}>
                            <Descriptions.Item label="Funding Amount" span={3}>
                              <Statistic
                                prefix="$"
                                precision={2}
                                value={amount}
                                valueStyle={{ fontSize: '14px' }}
                              />
                            </Descriptions.Item>
                            <Descriptions.Item
                              label="Condition of Allocation"
                              span={3}
                            >
                              {conditionOfAllocation}
                            </Descriptions.Item>
                          </Descriptions>
                        </List.Item>
                      )
                    )}
                </List>
              </Card>
            )}
          </Col>
        </Row>
      </Card>
      <Card title="Schedule" style={{ marginTop: '24px' }}>
        <List>
          <List.Item>
            <Descriptions title="Original Project Schedule">
              <Descriptions.Item label="Start Date">
                <DateDisplay date={profile && profile.originalStartDate} />
              </Descriptions.Item>
              <Descriptions.Item label="Completion Date">
                <DateDisplay date={profile && profile.originalCompletionDate} />
              </Descriptions.Item>
              <Descriptions.Item label="Last Approved Completion Date">
                <DateDisplay
                  date={profile && profile.lastApprovedCompletionDate}
                />
              </Descriptions.Item>
            </Descriptions>
          </List.Item>
          <List.Item>
            <Descriptions title="Actual Project Schedule">
              <Descriptions.Item label="Start Date">
                <DateDisplay date={profile && profile.actualStartDate} />
              </Descriptions.Item>
              <Descriptions.Item label="Completion Date">
                <DateDisplay date={profile && profile.actualCompletionDate} />
              </Descriptions.Item>
            </Descriptions>
          </List.Item>
          <List.Item>
            <Descriptions title="Deadline of Using Up Funding">
              <Descriptions.Item label="Original Deadline">
                <DateDisplay
                  date={profile && profile.deadlineOfUsingUpFunding}
                />
              </Descriptions.Item>
            </Descriptions>
          </List.Item>
        </List>
      </Card>
      <Card title="Other" style={{ marginTop: '24px' }}>
        <Descriptions column={1}>
          {canViewProjectProposal && (
            <Descriptions.Item label="Proposal">
              {/* {profile && profile.proposal?.filename} */}
              <FileList files={profile?.proposal ? [profile?.proposal] : []} />
            </Descriptions.Item>
          )}
          {profile?.supplements?.length && (
            <Descriptions.Item label="Supplements">
              <FileList files={profile?.supplements} />
            </Descriptions.Item>
          )}
          <Descriptions.Item label="History Log">
            <SanitizedHTML dirty={profile?.historyLog} />
          </Descriptions.Item>
          {canViewHistoryLogByPMS && (
            <Descriptions.Item label="History Log by PMS Admin">
              <SanitizedHTML dirty={profile?.historyLogByPMS} />
            </Descriptions.Item>
          )}
        </Descriptions>
      </Card>
    </>
  ) : (
    <EmptyProfile />
  );
};

ProfileDescriptions.propTypes = {};

export default ProfileDescriptions;
